import React, { useState, useEffect } from "react";
import { API } from "aws-amplify";
import Cookie from 'js-cookie';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTicketAlt, faPlus, faInfoCircle, faCreditCard } from '@fortawesome/free-solid-svg-icons'
import { Form, Row, Col, Button, Badge, Modal } from "react-bootstrap";
import CreditCardInput from 'react-credit-card-input';
import { LinkContainer } from "react-router-bootstrap";
import ReactSrcDocIframe from 'react-srcdoc-iframe'
import { useHistory } from "react-router-dom";
import InputMask from 'react-input-mask';
import Cleave from 'cleave.js/react';

import CartSummaryCard from './CartSummaryCard'
import LoaderButton from "components/LoaderButton";
import CardGroup from "components/common/CardGroup";

import { useCart } from "libs/cartLib";
import { useAnalytics } from "libs/analytics";
import { useFormFields, withISO8859Validation, isValidNIT } from "libs/hooksLib";
import { useAppContext } from "libs/contextLib";
import { renderCountryOptions } from "libs/formsLib";
import { onError, Notification } from "libs/errorLib";
import { db } from 'libs/firebase'
// import { useRecaptcha } from "libs/recaptchLib";
import config from 'config';

import './Cart.css'


// setRedirectContent(content)

// Card type detection utility
function getCardType(number) {
  if (!number) return 'unknown';
  const cleaned = number.replace(/\D/g, '');
  if (/^4/.test(cleaned)) return 'visa';
  if (/^5[1-5]/.test(cleaned) || /^2(2[2-9][1-9]|2[3-9][0-9]|[3-6][0-9]{2}|7[01][0-9]|720)/.test(cleaned)) return 'mastercard';
  if (/^3[47]/.test(cleaned)) return 'amex';
  return 'unknown';
}

function CreditCardNameField({ value, onChange, error }) {
  return (
    <Form.Group as={Col} controlId="ccName">
      <Form.Label>Nombre en la tarjeta*</Form.Label>
      <Form.Control
        autoComplete="off"
        placeholder="ej: José Perez"
        value={value}
        onChange={onChange}
        className={error ? "field-error" : "field-ok"}
      />
    </Form.Group>
  );
}

function CreditCardInputField({ value, onChange, error, handleFieldChange }) {
  return (
    <Form.Group as={Col} controlId="ccNumber">
      <Form.Label>Número de tarjeta*</Form.Label>
      <Cleave
        options={{ creditCard: true }}
        value={value}
        onChange={e => handleFieldChange({ target: { id: 'ccNumber', value: e.target.value } })}
        className={`form-control field-cc-number ${error ? "field-error" : "field-ok"}`}
        placeholder="•••• •••• •••• ••••"
        name="ccNumber"
        id="ccNumber"
        autoComplete="cc-number"
      />
    </Form.Group>
  );
}

function CreditCardExpiryField({ value, onChange, error, handleFieldChange }) {
  return (
    <Form.Group as={Col} controlId="ccExpiry">
      <Form.Label>Vence*</Form.Label>
      <Cleave
        options={{ date: true, datePattern: ['m', 'y'] }}
        value={value}
        onChange={e => handleFieldChange({ target: { id: 'ccExpiry', value: e.target.value } })}
        className={`form-control ${error ? "field-error" : "field-ok"}`}
        placeholder="MM/AA"
        name="ccExpiry"
        id="ccExpiry"
        autoComplete="cc-exp"
      />
    </Form.Group>
  );
}

function CreditCardCVVField({ value, cardNumber, onChange, onInput, error }) {
  const cardType = getCardType(cardNumber);
  const maxLength = cardType === 'amex' ? 4 : 3;
  return (
    <Form.Group as={Col} controlId="ccCvv2">
      <Form.Label>Cód. seguridad*</Form.Label>
      <Form.Control
        type="password"
        inputMode="numeric"
        autoComplete="off"
        maxLength={maxLength}
        placeholder="CVV"
        value={value}
        onChange={onChange}
        onInput={onInput}
        className={error ? "field-error" : "field-ok"}
      />
    </Form.Group>
  );
}

export default function CreditCardForm(props) {
    const { user, hideSaveData = false, ...otherProps } = props

    const [isLoading, setIsLoading] = useState(false)
    const [orderTotal, setOrderTotal] = useState(0)
    const [cart, setCart] = useState(null)
    const [cardUpdated, setCardUpdated] = useState(true)
    const [cardError, setCardError] = useState(false)
    const [customFieldSettings, setCustomFieldSettings] = useState(false)

    const { trackEvent } = useAnalytics();
    const { getSession, updateCartCounter } = useAppContext();    
    const { getCart, createOrder, updatePaymentInfo, getTotalItems } = useCart();   
    const [checkoutPaymentInfo, setCheckoutPaymentInfo] = useState(null)
    const [showRedirectModal, setShowRedirectModal] = useState(false)
    const [redirectContent, setRedirectContent] = useState('<html />')

    const history = useHistory();
    
    const [fields, handleFieldChange] = useFormFields({
        // Pre-fill with user data if available, otherwise empty
        cc: user,
        ccFirstname: user?.firstname || "",
        ccLastname: user?.lastname || "",
        ccEmail: user?.email || "",
        ccPhone: user?.phone || "",
        ccAddress: user?.address || "",
        ccCity: user?.city || "",
        ccState: user?.state || "",
        ccCountry: user?.country || "GT",
        ccZip: user?.zip || "",
        ccNit: user?.nit || "",
        ccName: "",
        ccNumber: "",
        ccExpiry: "",
        ccCvv2: "",
        ccSaveInfo: !hideSaveData, // Default to true unless hideSaveData is true
    });

    console.log('fields', fields)
    console.log('user', user)
    // Use the enhanced withISO8859Validation from hooksLib
    const handleValidatedFieldChange = withISO8859Validation(        
        handleFieldChange,
        {
            skipFields: ['card-number', 'card-expiry', 'cvc'],
            customHandler: {
                fields: ['card-number', 'card-expiry', 'cvc'],
                handler: handleCardInputChange
            },
            onError: (message) => Notification('error', message)
        }
    );

    function handleCardInputChange(event) {
        console.log('handleCardInputChange', event)
        const value = event.target.value;

        console.log('handleCardInputChange', event.target.id, event.target.value)
        
        // Validate ISO 8859-1 characters as user types
        if (value && !isValidISO8859(value)) {
            event.preventDefault();
            Notification('error', 'Por favor ingresa solo caracteres válidos');
            return;
        }

        // Add CVV validation for real-time feedback
        if (event.target.id === 'cvc' && value) {
            if (/^0{2,}$/.test(value) || /^9{2,}$/.test(value)) {
                setCardError(true);
                Notification('error', 'El código de seguridad no puede ser una secuencia de tres o más ceros o nueves');
                return;
            }
        }

        switch(event.target.id) {
            case 'card-number': {
                event.target.id = 'ccNumber'
                break;
            }
            case 'card-expiry': {
                event.target.id = 'ccExpiry'
                break;
            }
            case 'cvc': {
                event.target.id = 'ccCvv2'
                break;
            }
        }
        handleFieldChange(event)
        setCardUpdated(false)
        setCardError(false)
    }

    // const { initRecaptcha, executeRecaptcha } = useRecaptcha();
    

    // useEffect(() => {

    //     // const searchParams = new URLSearchParams(location.search);
    //     // if (searchParams.get('activated') == "1") {
    //     //     //Notification('success','Tu boleto ha sido activado exitosamente')
    //     //     setShowActivationModal(false)        
    //     // }
    
    //     async function onLoad() {
    //         try {           
    //             setIsLoading(true)
    //             session = await getSession()
                                
    //             // if (isAuthenticated) {    
    //             //     console.log(session, show)            
    //             //     const vShow = await loadViewerShow(session.viewer._id, show._id)
    //             // }
    
    //         } catch (e) {
    //             onError(e);
    //         } finally {
    //             setIsLoading(false)
    //         }
    //     }
    
    //     onLoad();
    // }, []);  
    useEffect(() => {        
        onLoad()         
        
    }, [cart]);

    async function onLoad() {
        let cart
        try {
            cart = await getCart()
            setCart(cart || {})

            let fields = []
            const rule = cart.price_rules.find(r => r.rule_type == 'custom_fields')
            if (rule) {
                fields = rule.fields
            }
            setCustomFieldSettings(fields)

        } catch (e) {
            // no cart
        }
    }

    useEffect(() => {
        // initRecaptcha()
    }, []);


    async function processUpdatePaymentInfo(payment_type, payment_info) {
        const session = await getSession()

        const payload = {
            // user_uid: session.user._id,
            payment_type: payment_type,
            currency: cart?.currency || 'GTQ',
            payment_info: payment_info,                
        }
        const purchase = await updatePaymentInfo(payload)
        setCart(updateCartCounter())

        // const purchase = await API.post("vivelo", `/viewers/orders/`, {
        //     body: {
        //         user_uid: session.user._id,
        //         payment_type: payment_type,
        //         currency: 'GTQ',
        //         payment_info: payment_info,                
        //     }
        // });
        
        return purchase
    }

    async function processPayment(payment_type, payment_info) {
        const session = await getSession()

        const order = {
            user_uid: user?._id || null, // Allow null for guest purchases
            payment_type: payment_type,
            currency: cart?.currency || 'GTQ',
            payment_info: payment_info,                
        }
        const purchase = await createOrder(order)

        // const purchase = await API.post("vivelo", `/viewers/orders/`, {
        //     body: {
        //         user_uid: session.user._id,
        //         payment_type: payment_type,
        //         currency: 'GTQ',
        //         payment_info: payment_info,                
        //     }
        // });
        
        return purchase
    }



    /* VALIDATORS */
    function isValidISO8859(str) {
        // ISO 8859-1 valid characters range from 0x20 to 0xFF, excluding control characters
        const iso8859Regex = /^[\x20-\x7E\xA0-\xFF]*$/;
        return iso8859Regex.test(str);
    }

    function isValidCVV(cvv) {
        // Check if CVV is all zeros or all nines
        if (!cvv) return false;
        // Only check for sequences of 3 or more zeros or nines
        return !(/^0{2,}$/.test(cvv) || /^9{2,}$/.test(cvv));
    }

    function validateCreditCardForm() {
        // First check if all fields contain only valid ISO 8859-1 characters
        if (!isValidISO8859(fields.ccFirstname) || 
            !isValidISO8859(fields.ccLastname) ||
            !isValidISO8859(fields.ccEmail) ||
            !isValidISO8859(fields.ccPhone) ||
            !isValidISO8859(fields.ccAddress) ||
            !isValidISO8859(fields.ccCity) ||
            !isValidISO8859(fields.ccState) ||
            !isValidISO8859(fields.ccNit) ||
            !isValidISO8859(fields.ccName)) {
            return false;
        }

        // Add NIT validation for Guatemalan users
        if (['GT'].includes(fields.ccCountry) && !isValidNIT(fields.ccNit)) {
            return false;
        }

        // Add CVV validation
        if (!isValidCVV(fields.ccCvv2)) {
            return false;
        }

        const isValid = fields.ccFirstname.length > 0 
            && fields.ccLastname.length > 0
            && fields.ccEmail.length > 0
            && fields.ccEmail == fields.ccEmailConfirm
            && fields.ccPhone.length > 0 
            && fields.ccAddress.length > 0 
            && fields.ccCity.length > 0 
            && fields.ccState.length > 0 
            && fields.ccCountry.length > 0 
            && (
                (['GT'].includes(fields.ccCountry) && fields.ccNit.length > 0) ||
                (['US','CA'].includes(fields.ccCountry) && fields.ccZip.length > 0) ||
                (!['GT','US','CA'].includes(fields.ccCountry))
            )
            && validateCustomFields()
            && fields.ccName.length > 0 
            && fields.ccNumber            
            && fields.ccExpiry
            && fields.ccCvv2

            && !cardError;
            // && orderTotal > 0;
            console.log('validation', isValid)
        return isValid

    }

    function validateCustomFields() {
        let isValid = true
        if (Array.isArray(customFieldSettings)) {
            console.log('validating custom fields',customFieldSettings.filter(f => f.required))
            customFieldSettings.filter(f => f.required).forEach(f => {
                isValid = isValid && fields[f.key] ? fields[f.key].length > 0 : false
                console.log(f.key, fields[f.key], isValid)            
            })
        }
        return isValid
    }

    /* HANDLERS */
    function handleChangeOrderButton() {
        trackEvent({
            action: "Clicked ChangeOrder Button",
            category: "PurchaseFunnel"
        });
    }    
    
    async function handleCreditCardUpdate(event) {
        event.preventDefault();
        setIsLoading(true);
        trackEvent({
            action: "Clicked CreditCard Update Button",
            category: "PurchaseFunnel"
        });
        
        try {
            // const captchaResult = await executeRecaptcha('purchase')
            // if (!captchaResult.success) {
            //     Notification('error', 'Error de verificación.  Por favor vuelve a intentar.')                
            //     setIsLoading(false);
            //     return false
            // }

            const payment_info = {
                    payment_type: 'CREDIT_CARD',
                    cc_bin: fields.ccNumber.split(" ").join("").substring(0,6),                    
                    ...(cart?.payment_info?.provider && { provider: cart.payment_info.provider })
            }
                        
            const result = await processUpdatePaymentInfo(payment_info.payment_type, payment_info)
            if (result && result.approved) {
                setCardUpdated(true)
                return true
            } else {
                setCardUpdated(false)
                showTransactionError(result.response_code, result.response_text || 'No fue posible actualizar el carrito')
                setIsLoading(false);
                return false
            }        
            
        } catch(error) {
            setCardUpdated(false)
            if (error.response && error.response.data) {
                showTransactionError(error.response.data.response_code, error.response.data.response_text || 'No fue posible actualizar los datos')
            } else {
                showTransactionError('unknown', 'No fue posible actualizar los datos')
            }
            setIsLoading(false);
            return false
        } finally {
            setIsLoading(false);
        }

        
    }  

    async function add3dsListener(payment_info) {
        console.log(`3ds listening for "cart/${cart._id}/3ds/"`)
        const cart3dsRef = db.ref(`/cart/${cart._id}/3ds/`)
        await cart3dsRef.set(null)
        cart3dsRef.on('value', (snapshot) => {
            console.log('value', snapshot)
            if (!snapshot.val()) return

            console.log('3ds response', snapshot.val())
            const response = snapshot.val()
            if (response.approved) {
                // redirect to success
                cart3dsRef.off()
                // Notification('success', '3ds success')                
                payment_info.save_info = fields.ccSaveInfo
                props.onSuccess && props.onSuccess(payment_info, response)
                setIsLoading(false)
            } else {
                // close modal and show error message
                cart3dsRef.off()
                
                setShowRedirectModal(false)
                setIsLoading(false)
                showTransactionError(response.code, response.message)
                // Notification('error', 'No fue posible realizar la compra', null, 'top')
                props.onFailure && props.onFailure(response)
                setIsLoading(false);
                return false
            }
        })                        
        cart3dsRef.onDisconnect().remove()
    }

    function showTransactionError(error_code, error_message) {
      console.log('error_code', error_code)
      console.log('error_message', error_message)
        switch(error_code.toString()) {
            case '14': // Invalid card number
            case '41': // Lost card
            case '43': // Stolen card
                Notification('error', 'La transacción no pudo ser completada. Tarjeta no válida o no soportada.', null, 'top')
                break;
            case '19': // Re-enter transaction
            case '96': // System malfunction
                Notification('error', 'La transacción no pudo ser completada, por favor intenta nuevamente.', null, 'top')
                break;
            case '05': // Do not honor
            case '51': // Insufficient funds
            case '61': // Exceeds withdrawal amount limit
                Notification('error', 'Transacción rechazada por el banco emisor. Por favor revisa los datos ingresados o contacta a tu banco para autorizar la transacción', null, 'top')
                break;
            case '59': // Suspected fraud
                Notification('error', 'Transacción rechazada por el sistema antifraude. Intenta de nuevo en 24 horas.', null, 'top')
                break;
            case '65': // Limit exceeded
                Notification('error', 'Límite de transacciones excedido. NO REINTENTAR', null, 'top')
                break;
            case '91': // Switch now a
                Notification('error', 'Tarjeta no soportada. NO REINTENTAR', null, 'top')
                break;
            case '5001': // Price rule
                Notification('error', error_message || 'Tarjeta inválida para esta operación', null, 'top')
                break;
            case 'SP4': // 3D Secure processing
                Notification('info', 'Se requiere autenticación adicional. Por favor, sigue las instrucciones en la siguiente pantalla.', null, 'top')
                break;
            case '97': // Request Validation Failed
                    Notification('error', 'Error de validación. Por favor, verifica los datos ingresados.', null, 'top')
                break;
            case '3D0': // Request Validation Failed
                    Notification('error', 'Tarjeta no soporta verificación antifraude. Por favor, intenta con otra tarjeta.', null, 'top')
                break;
            case '3D1': // Request Validation Failed
                Notification('error', 'Tarjeta no soporta verificación antifraude. Por favor, intenta con otra tarjeta.', null, 'top')
                break;
            case '3D2': // Request Validation Failed
                // Notification('error', error_message || 'Error de validación. Por favor, verifica los datos ingresados.', null, 'top')
                Notification('error', 'Error de validación. Por favor, verifica los datos ingresados.', null, 'top')
                break;
            default:
                Notification('error', error_message || 'La transacción ha sido denegada. Revisa que todos los datos estén correctos.', null, 'top')
                break;
        }
    }

    async function handleSubmitCreditCard(event) {    
        event.preventDefault();
        setIsLoading(true);
        
        trackEvent({
            action: "Clicked Pay Button",
            category: "PurchaseFunnel"
        });
        let payment_info = {}
        
        try {
            // const captchaResult = await executeRecaptcha('purchase')
            // if (!captchaResult.success) {
            //     Notification('error', 'Error de verificación.  Por favor vuelve a intentar.')                
            //     setIsLoading(false);
            //     return false
            // }

            payment_info = {
                    firstname: fields.ccFirstname,
                    lastname: fields.ccLastname,
                    email: fields.ccEmail,
                    phone: fields.ccPhone,
                    address: fields.ccAddress,
                    city: fields.ccCity,
                    state: fields.ccState,
                    country: fields.ccCountry,
                    nit: fields.ccNit || "C/F",
                    zip: fields.ccZip || "",
                    cc_name: fields.ccName,
                    cc_number: fields.ccNumber.split(" ").join(""),
                    cc_exp: fields.ccExpiry.split(" ").join(""),
                    cc_cvv2: fields.ccCvv2,
                    currency: cart?.currency || 'GTQ',
                    total: orderTotal,
                    sessionId: Cookie.get('sessionID'),
                    ...(cart?.payment_info?.provider && { provider: cart.payment_info.provider })
            }

            if (Array.isArray(customFieldSettings)) {
                let custom_fields = {}
                customFieldSettings.forEach(f => {
                    custom_fields[f.key] = fields[f.key] || null
                })
                payment_info.custom_fields = custom_fields
            }
            setCheckoutPaymentInfo(payment_info)
                  
            const purchase = await processPayment('CREDIT_CARD', payment_info)
            if (purchase) {
                // console.log(purchase)
                //setIsLoading(false);
                payment_info.save_info = hideSaveData ? false : fields.ccSaveInfo
                await props.onSuccess && props.onSuccess(payment_info, purchase)
                // history.push(`/orders/${purchase.id}`)
                return true
            } else {
                Notification('error', 'No fue posible realizar la compra', null, 'top')
                props.onFailure && props.onFailure(purchase)
                setIsLoading(false);
                return false
            }        
            
        } catch(error) {
            if (error.response) {
                const responseData = error.response.data
                switch(error.response.status) {
                    case 303: // processing 3ds
                        console.log(`Processing 3DS redirect: ${responseData.payment_response.redirect}`)
                        await add3dsListener(payment_info)
                        setRedirectContent(responseData.payment_response.redirect)
                        setShowRedirectModal(true)
                        return;
                    case 402: // payment failed
                        showTransactionError(responseData.response_code, responseData.response_text)
                        break;
                    default:
                        showTransactionError(responseData?.response_code || 'unknown', responseData?.response_text || 'No fue posible realizar la compra')
                        break;
                }
                setIsLoading(false);
            } else {
                showTransactionError('unknown', 'No fue posible realizar la compra')
                setIsLoading(false);
            }
            return false
        } finally {
          setIsLoading(false);
        }

        
    }  

    function renderDeviceFingerprintPixel() {
        const ordId = config.fingerprint.ordId;
        const x_login = config.fingerprint.login;
        const sessionId = Cookie.get('sessionID');

        return <><p style={{background:`url('https://h.online-metrix.net/fp/clear.png?org_id=$${ordId}&session_id=${x_login}${sessionId}&m=1')`}}></p>
            <img src={`https://h.online-metrix.net/fp/clear.png?org_id=$${ordId}&session_id=${x_login}${sessionId}&m=2`} alt=""></img></>
    }

    function renderCustomFields() {

        const customFields = []
        if (Array.isArray(customFieldSettings)) {
            customFieldSettings .forEach(f => {
                let field = null
                switch(f.type) {
                    case 'text': {
                        field = <>
                        <Form.Group as={Col} controlId={f.key}>
                        <Form.Label>{f.label}{f.required && '*'}</Form.Label>
                        <Form.Control type="text" placeholder="" value={fields[f.key]} onChange={handleFieldChange}  className={f.required && !fields[f.key] ? "field-error" : "field-ok"} />
                        </Form.Group>
                        </>
                        break;
                    }
                    case 'option': {

                        let options = f.options.map(o => {
                            const default_key = f.default
                            const default_val = Cookie.get(default_key)
                            const selected = default_val == o.key ? true : false

                            if (selected && !fields[f.key]) {
                                handleFieldChange({
                                    target: { 
                                        id: f.key, 
                                        value: default_val
                                    }
                                })
                            }

                            return <option value={o.key} selected={selected ? 'selected' : ''}>{o.value}</option>
                        })
                        options.unshift(<option value={``}>{``}</option>)

                        field = <>
                        <Form.Group as={Col} controlId={f.key}>
                        <Form.Label>{f.label}{f.required && '*'}</Form.Label>                        
                        <Form.Control as="select" value={fields[f.key]} onChange={handleFieldChange} className={f.required && !fields[f.key] ? "field-error" : "field-ok"} >
                            {options}
                        </Form.Control>
                        </Form.Group>
                        </>
                        break;
                    }
                }

                customFields.push(field)
            })
        }

        return customFields.length ? <Form.Row>{customFields}</Form.Row> : <></>
    }

    function handleModalClose() {
        setShowRedirectModal(false)
    }

    function renderRedirectModal() {
                

        return <Modal size="xl" centered show={showRedirectModal} onHide={handleModalClose} 
            backdrop="static" keyboard={false}
            dialogClassName="cart-redirect-modal-content"
            >
        {/* <Modal.Header closeButton>
          <Modal.Title>Activar Código</Modal.Title>
        </Modal.Header> */}
        <Modal.Body>
            <div className="cart-redirect-modal-title">
                <span>Procesando tu pago</span>
                <div class="cart-redirect-modal-processing-animation">
                    <div className="cart-redirect-modal-processing-circle"></div>                    
                </div>
            </div>
            <div >
                <div className="cart-redirect-modal-processing-3ds-container">
                    <div className="redirect-modal-message">
                        Por favor espera mientras procesamos tu pago de forma segura...
                    </div>
                    <div className="cart-redirect-modal-redirect-modal-3ds-container">
                        <div className="cart-redirect-modal-redirect-modal-icon">
                            <div className="cart-redirect-modal-security-icon"></div>
                        </div>
                        {redirectContent ? <ReactSrcDocIframe srcDoc={redirectContent} 
                    width="100%" height="430" className="cart-redirect-modal-iframe" /> : 
                    null }
                    </div>
                    
                </div>
                
                    
                
            </div>
            
        </Modal.Body>        
      </Modal>
    }

    function renderSaveDataCheckbox() {
        if (hideSaveData) return null;

        return (
            <Form.Group controlId="ccSaveInfo">
                <Form.Check
                    type="checkbox"
                    label="Guardar información para futuras compras"
                    checked={fields.ccSaveInfo}
                    onChange={handleFieldChange}
                />
            </Form.Group>
        );
    }

    function renderCreditCardForm() {
        return (
          <div className="cart-main-layout">
            <div className="cart-left">
              <Form>

              <CardGroup title="Datos de tarjeta">
                  <Form.Row>
                    <CreditCardNameField
                      value={fields.ccName}
                      onChange={handleValidatedFieldChange}
                      error={fields.ccName === ""}
                    />
                  </Form.Row>
                  <Form.Row>
                    <CreditCardInputField
                      value={fields.ccNumber}
                      onChange={handleValidatedFieldChange}
                      handleFieldChange={handleFieldChange}
                      error={fields.ccNumber === ""}
                    />
                  </Form.Row>
                  <Form.Row>
                    <CreditCardExpiryField
                      value={fields.ccExpiry}
                      onChange={handleValidatedFieldChange}
                      handleFieldChange={handleFieldChange}
                      error={fields.ccExpiry === ""}
                    />
                    <CreditCardCVVField
                      value={fields.ccCvv2}
                      cardNumber={fields.ccNumber}
                      onChange={handleValidatedFieldChange}
                      onInput={handleCardInputChange}
                      error={fields.ccCvv2 === ""}
                    />
                  </Form.Row>
                  <Form.Row style={{'textAlign':'center', 'borderTop': 'solid 1px #27272a', 'marginTop': 20, 'paddingTop': 20}}>
                    <img src="/img/branding-fac-tarjetas-blanco-h.png" alt="FAC" style={{width:200, marginLeft:'auto', marginRight:'auto'}} />
                  </Form.Row>
                  {renderDeviceFingerprintPixel()}
                </CardGroup>
                
                <CardGroup
                  title="Datos personales"
                  extra={
                    <Form.Row>
                      {renderSaveDataCheckbox()}
                    </Form.Row>
                  }
                >
                  <Form.Row>
                    <Form.Group as={Col} controlId="ccFirstname">
                      <Form.Label>Nombre*</Form.Label>
                      <Form.Control required placeholder="ej: José" value={fields.ccFirstname} onChange={handleValidatedFieldChange} className={fields.ccFirstname == "" ? "field-error" : "field-ok"} />
                    </Form.Group>
                    <Form.Group as={Col} controlId="ccLastname">
                      <Form.Label>Apellido*</Form.Label>
                      <Form.Control placeholder="ej: Pérez" value={fields.ccLastname} onChange={handleValidatedFieldChange} className={fields.ccLastname == "" ? "field-error" : "field-ok"} />
                    </Form.Group>
                  </Form.Row>
                  <Form.Row>
                    <Form.Group as={Col} controlId="ccEmail">
                      <Form.Label>Email*</Form.Label>
                      <Form.Control type="email" placeholder="" value={fields.ccEmail} onChange={handleValidatedFieldChange} className={fields.ccEmail == "" ? "field-error" : "field-ok"} />
                    </Form.Group>
                    <Form.Group as={Col} controlId="ccEmailConfirm">
                      <Form.Label>Confirmar Email*</Form.Label>
                      <Form.Control type="email" placeholder="" value={fields.ccEmailConfirm} onChange={handleValidatedFieldChange} className={fields.ccEmailConfirm != fields.ccEmail ? "field-error" : "field-ok"} />
                    </Form.Group>
                  </Form.Row>
                  <Form.Row>
                    <Form.Group as={Col} controlId="ccPhone">
                      <Form.Label>Telefono*</Form.Label>
                      <Form.Control type="tel" placeholder="" value={fields.ccPhone} onChange={handleValidatedFieldChange} className={fields.ccPhone == "" ? "field-error" : "field-ok"} />
                    </Form.Group>
                    <Form.Group as={Col} controlId="ccAddress">
                      <Form.Label>Direcci&oacute;n*</Form.Label>
                      <Form.Control value={fields.ccAddress} onChange={handleValidatedFieldChange} className={fields.ccAddress == "" ? "field-error" : "field-ok"} />
                    </Form.Group>
                  </Form.Row>
                  <Form.Row>
                    <Form.Group as={Col} controlId="ccCity">
                      <Form.Label>Municipio/Ciudad*</Form.Label>
                      <Form.Control value={fields.ccCity} onChange={handleValidatedFieldChange} className={fields.ccCity == "" ? "field-error" : "field-ok"} />
                    </Form.Group>
                    <Form.Group as={Col} controlId="ccState">
                      <Form.Label>Departamento/Estado*</Form.Label>
                      <Form.Control value={fields.ccState} onChange={handleValidatedFieldChange} className={fields.ccState == "" ? "field-error" : "field-ok"} />
                    </Form.Group>
                    <Form.Group as={Col} controlId="ccCountry">
                      <Form.Label>Pa&iacute;s*</Form.Label>
                      <Form.Control as="select" value={fields.ccCountry} onChange={handleValidatedFieldChange}>
                        {renderCountryOptions()}
                      </Form.Control>
                    </Form.Group>
                  </Form.Row>
                  {['GT'].includes(fields.ccCountry) && (
                    <Form.Row>
                      <Form.Group as={Col} controlId="ccNit">
                        <Form.Label>NIT <span style={{ fontSize: '1rem' }}>("C/F" si no tienes NIT)</span></Form.Label>
                        <Form.Control
                          value={fields.ccNit}
                          onChange={handleValidatedFieldChange}
                          className={!isValidNIT(fields.ccNit) ? "field-error" : "field-ok"}
                          onBlur={e => {
                            if (e.target.value && !isValidNIT(e.target.value)) {
                              Notification('error', 'NIT inválido. Por favor verifica el formato o usa C/F.');
                            }
                          }}
                        />
                      </Form.Group>
                    </Form.Row>
                  )}
                  {['US', 'CA'].includes(fields.ccCountry) && (
                    <Form.Row>
                      <Form.Group as={Col} controlId="ccZip">
                        <Form.Label>Zip Code</Form.Label>
                        <Form.Control value={fields.ccZip} onChange={handleValidatedFieldChange} className={fields.ccZip == "" ? "field-error" : "field-ok"} />
                      </Form.Group>
                    </Form.Row>
                  )}
                  {renderCustomFields()}
                </CardGroup>
                
                {renderRedirectModal()}
              </Form>
            </div>
            <div className="cart-right">
              <CartSummaryCard
                cart={cart}
                getTotalItems={getTotalItems}
                mode="payment"
                onPay={validateCreditCardForm() ? handleSubmitCreditCard : null}
                onModify={() => history.push('/')}
                isLoading={isLoading}
              />
            </div>
          </div>
        );
    }

    return renderCreditCardForm()
}
